import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle, XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-stone-950 text-stone-50 py-24 px-4 border-t border-stone-800" data-id="element-121">
      <div className="max-w-5xl mx-auto" data-id="element-122">
        <FadeIn data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-black mb-12 text-center text-amber-500" data-id="element-124">
            El problema no es que estés viejo.
          </h2>

          <div className="bg-stone-900 p-8 md:p-12 rounded-2xl border border-stone-800 shadow-2xl mb-16" data-id="element-125">
            <p className="text-xl md:text-2xl leading-relaxed text-stone-300 mb-8" data-id="element-126">
              El problema es que tus articulaciones están operando{' '}
              <strong className="text-stone-50" data-id="element-127">"en seco"</strong>. Durante la
              noche, el lubricante natural de tu cuerpo se vuelve espeso como
              miel fría. Cuando saltas de la cama directamente al suelo, causas
              una fricción que inflama tus tejidos y desgasta tu cartílago.
            </p>

            <div className="flex items-start gap-4 bg-red-950/30 p-6 rounded-xl border border-red-900/50" data-id="element-128">
              <AlertTriangle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-129" />
              <p className="text-lg md:text-xl text-stone-300" data-id="element-130">
                Si sigues ignorando esta rigidez, el destino es inevitable:
                cirugías costosas, bastones antes de tiempo y la tristeza de no
                poder cargar a tus nietos o jugar un partido de fútbol el fin de
                semana.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-131">
            <div className="bg-red-950/20 border border-red-900/30 p-8 rounded-2xl" data-id="element-132">
              <h3 className="text-2xl font-black text-red-400 mb-6 flex items-center gap-3" data-id="element-133">
                <XCircle className="w-8 h-8" data-id="element-134" />
                TU MAÑANA HOY
              </h3>
              <ul className="space-y-4 text-lg text-stone-300" data-id="element-135">
                <li className="flex items-center gap-3" data-id="element-136">
                  <span className="text-red-500" data-id="element-137">✗</span> Dolor al primer paso
                </li>
                <li className="flex items-center gap-3" data-id="element-138">
                  <span className="text-red-500" data-id="element-139">✗</span> Rigidez por 30+
                  minutos
                </li>
                <li className="flex items-center gap-3" data-id="element-140">
                  <span className="text-red-500" data-id="element-141">✗</span> Dependencia de
                  pastillas
                </li>
                <li className="flex items-center gap-3" data-id="element-142">
                  <span className="text-red-500" data-id="element-143">✗</span> Miedo a las escaleras
                </li>
              </ul>
            </div>

            <div className="bg-amber-900/20 border border-amber-500/30 p-8 rounded-2xl relative overflow-hidden" data-id="element-144">
              <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 blur-3xl rounded-full" data-id="element-145" />
              <h3 className="text-2xl font-black text-amber-400 mb-6 flex items-center gap-3 relative z-10" data-id="element-146">
                <CheckCircle2 className="w-8 h-8" data-id="element-147" />
                TU MAÑANA CON LSA
              </h3>
              <ul className="space-y-4 text-lg text-stone-100 relative z-10 font-medium" data-id="element-148">
                <li className="flex items-center gap-3" data-id="element-149">
                  <span className="text-amber-500" data-id="element-150">✓</span> Te levantas con
                  fluidez
                </li>
                <li className="flex items-center gap-3" data-id="element-151">
                  <span className="text-amber-500" data-id="element-152">✓</span> Movilidad desde el
                  minuto 1
                </li>
                <li className="flex items-center gap-3" data-id="element-153">
                  <span className="text-amber-500" data-id="element-154">✓</span> Cero químicos
                </li>
                <li className="flex items-center gap-3" data-id="element-155">
                  <span className="text-amber-500" data-id="element-156">✓</span> Subes escaleras sin
                  pensarlo
                </li>
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}